import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading.asObservable();
  /**
   * show the loader icon
   */
  showLoader():void {
    this.isLoading.next(true);
  }

  /**
   * hide the loader icon
   */
  hideLoader():void {
    this.isLoading.next(false);
  }

  /**
   * Returns true if the loader is currently visible.
   * Use this to check whether an external operation opened the loader
   * before deciding whether to close it.
   */
  get isCurrentlyLoading(): boolean {
    return this.isLoading.getValue();
  }
}
